export default {
  hero: {
    title: 'AllChinaBuy Spreadsheet — Trouvez des produits, vendeurs et ressources d\'achat',
    subtitle: 'Explorez le tableur AllChinaBuy, les ressources produits, les guides vendeurs, les informations QC, les guides d\'expédition et les conseils pratiques d\'achat en un seul endroit. Faites des recherches plus intelligentes avant de commander.',
    ctaMain: 'Explorer le tableur AllChinaBuy',
    ctaSecondary: 'Guide débutant',
    ctaAllChinaBuy: 'Tableur AllChinaBuy',
    ctaBuyNow: 'Acheter maintenant',
  },
  categories: {
    title: 'Catégories populaires',
    subtitle: 'Parcourez les catégories de produits et trouvez exactement ce que vous cherchez',
  },
  articles: {
    title: 'Derniers guides et ressources',
    subtitle: 'Recherches originales, conseils d\'achat et guides pratiques pour vous aider à acheter plus intelligemment',
  },
  features: {
    title: 'Pourquoi utiliser le tableur AllChinaBuy ?',
    item1: 'Liens produits organisés auprès de vendeurs de confiance',
    item2: 'Photos QC et conseils de vérification qualité',
    item3: 'Estimations de coûts d\'expédition et comparaisons',
    item4: 'Mises à jour actives des coupons et codes de réduction',
  },
  seo: {
    title: 'AllChinaBuy Spreadsheet 2026 — Produits, Vendeurs, QC & Expédition',
    description: 'Explorez le tableur AllChinaBuy, les ressources produits, les guides vendeurs, les informations QC et les guides d\'expédition en un seul endroit.',
    keywords: 'AllChinaBuy, tableur, guide d\'achat, expédition, QC, coupon, réduction',
  },
};